import ProductsListing from "../../components/features/products-listing/ProductsListing";

const ProductsListingPage = () => {
  return <ProductsListing />;
};

export default ProductsListingPage;
